import fly from './fly'
import { getAuth } from '@/util/storage'
const auth =  getAuth() // 'EKRFP70gGVW2bCjlsaFT9rVLMGgAQ9Sjjpd8cvB-m16W0YjnKLdOvFo1qSq2y-Uw'

export const fetchStoreList = ({ lng, lat }: any) =>
  fly
    .get(`/base/actapi/api/actB/store2List.html`, { lng, lat })
    .then(res => res.data)

// 门店详细信息
export const fetchStoreDetail = (store_id: any) =>
  fly
    .get(`/base/actapi/api/actB/storeDetail.html`, { store_id })
    .then(res => res.data)

export const fetchBookDetail = (id: string) =>
  fly.get(`/base/actapi/api/actB/reserveDetail.html`, { id, auth })

  // 提交订单
export const fetchSubmitOrder = (params: Object) =>
  fly.post(`/base/actapi/api/actB/addReserve.html`, { ...params, auth })
  .then(res => res.data)
